import React from "react";

interface StatusBadgeProps {
  /** The status code (e.g., "ACTIVE", "INACTIVE") used for styling */
  statusCode: string;
  /** The translated/label text to display */
  label: string;
  className?: string;
}

/**
 * StatusBadge
 * Reusable component for displaying status with consistent styling.
 * Shows green badge for ACTIVE status, red for others.
 * Translation logic should be handled by the parent component.
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  statusCode,
  label,
  className = "",
}) => {
  const isActive = statusCode === "ACTIVE";
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded-full text-xs leading-none ${className} ${
        isActive ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
      }`}
    >
      {label}
    </span>
  );
};

